import { render, staticRenderFns } from "./monitorPage.vue?vue&type=template&id=68d0fc55&"
import script from "./monitorPage.vue?vue&type=script&lang=js&"
export * from "./monitorPage.vue?vue&type=script&lang=js&"
import style0 from "./monitorPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports